import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { QUERY_KEY_CHAT_THREADS } from './useChatThreads';

interface CreateTestThreadInput {
  phoneNumber: string;
  senderName: string;
}

interface CreateTestThreadResponse {
  threadId: string;
  createdAt: string;
}

export function useCreateTestChat() {
  const queryClient = useQueryClient();

  return useMutation<CreateTestThreadResponse, Error, CreateTestThreadInput>({
    mutationFn: async ({ phoneNumber, senderName }) => {
      const { data } = await api.post<CreateTestThreadResponse>('/chat/threads', { phoneNumber, senderName });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_CHAT_THREADS] });
    },
  });
}
